import React, { useState } from 'react';
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Auth.css';
import googleLogo from '../assets/google-logo.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/home');
    } catch (error) {
      console.error('Error logging in:', error);
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // After Google Sign-In, check if the user already has an artistName
      const response = await axios.get(`https://sync-api-troz.onrender.com/api/users/firebase/${user.uid}`);

      // Check if the artistName exists, if not, navigate to profile setup
      if (response.data.artistName) {
        navigate('/home');
      } else {
        navigate('/profile-setup');
      }
    } catch (error) {
      console.error('Error with Google Sign-In:', error);
    }
  };

  return (
    <div className="auth-container">
      <h2 className='auth-header'>Log in to Sync</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="auth-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="auth-input"
        />
        <button type="submit" className="auth-button">Log In</button>
      </form>
      <button onClick={handleGoogleSignIn} className="auth-button google-signin">
        <img src={googleLogo} alt='google-logo' />
        Sign in with Google
      </button>

      <p className="auth-link">
        Don’t have an account yet? <Link to="/signup">Sign Up</Link>
      </p>
      
    </div>
  );
};

export default Login;
